<script>
export default {
    name: 'MenuMonitoramento',
    props: {
        me: null
    }
};
</script>

<template>
    <li class="dropdown nav-item" v-if="me.admin || me.acesso_monitoramento">
        <a href="#" class="nav-link dropdown-toggle " data-toggle="dropdown" 
           role="button" aria-haspopup="true" aria-expanded="false">
            <i class="fa fa-desktop"></i> MONITORAMENTO <span class="caret"></span>
        </a>
        <ul class="dropdown-menu monitoramento-dropdown">
            <li><a :href="'#/rastreamento'" class="menu-item">
                <i class="fa fa-map text-primary"></i> 
                <span>Rastreamento Simples</span>
                <small class="text-muted">Visão básica dos veículos</small>
            </a></li>
            
            
            <li><a :href="'#/rastreamento-completo'" class="menu-item">
                <i class="fa fa-map-o text-success"></i> 
                <span>Rastreamento Completo</span>
                <small class="text-muted">Visão detalhada com histórico</small>
            </a></li>
            
            
            <li><a href="#/maps-rastreamento" class="menu-item">
                <i class="fa fa-globe text-info"></i> 
                <span>Rastreamento com Mapa</span>
                <small class="text-muted">Localização em tempo real</small>
            </a></li>
            
            
            <li><a :href="'#/alertas'" class="menu-item">
                <i class="fa fa-bell text-warning"></i> 
                <span>Alertas</span>
                <small class="text-muted">Notificações e eventos</small>
            </a></li>
            
            
            <li><a href="#/all-maps" class="menu-item">
                <i class="fa fa-car text-danger"></i> 
                <span>Mapa com Todos os Veículos</span>
                <small class="text-muted">Visão geral da frota</small>
            </a></li>
        </ul>
    </li>
</template>

<style scoped>
.monitoramento-menu-toggle {
    font-size: 13px;
    font-weight: 600;
    color: #2c3e50 !important;
    text-decoration: none;
    transition: all 0.3s ease;
    padding: 15px 20px;
}

.monitoramento-menu-toggle:hover {
    color: #27ae60 !important;
    background-color: rgba(39, 174, 96, 0.1);
}

.monitoramento-menu-toggle i {
    margin-right: 8px;
    font-size: 14px;
}

.monitoramento-dropdown {
    min-width: 300px;
    border-radius: 8px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
    border: none;
    padding: 10px 0;
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
}

.menu-item {
    padding: 12px 20px !important;
    color: #2c3e50 !important;
    text-decoration: none !important;
    display: flex !important;
    align-items: center;
    transition: all 0.3s ease;
    border-left: 3px solid transparent;
}

.menu-item:hover,
.menu-item:focus {
    background: linear-gradient(90deg, rgba(39, 174, 96, 0.1) 0%, rgba(39, 174, 96, 0.05) 100%);
    color: #2c3e50 !important;
    text-decoration: none !important;
    border-left: 3px solid #27ae60;
    transform: translateX(2px);
}

.menu-item i {
    font-size: 16px;
    width: 20px;
    margin-right: 12px;
    text-align: center;
}

.menu-item span {
    font-weight: 600;
    flex: 1;
}

.menu-item small {
    display: block;
    font-size: 11px;
    margin-top: 2px;
    margin-left: 32px;
    font-weight: normal;
}

.menu-divider {
    height: 1px;
    background: linear-gradient(90deg, transparent 0%, #e9ecef 50%, transparent 100%);
    margin: 8px 20px;
}

.fa-cars {
    color: #e74c3c !important;
}

/* Animação para o dropdown */
.monitoramento-dropdown {
    opacity: 0;
    transform: translateY(-10px);
    transition: all 0.3s ease;
}

.dropdown.open .monitoramento-dropdown {
    opacity: 1;
    transform: translateY(0);
}

/* Responsividade */
@media (max-width: 767px) {
    .monitoramento-dropdown {
        min-width: 280px;
        margin-top: 5px;
    }
    
    .menu-item {
        padding: 10px 15px !important;
    }
    
    .menu-item small {
        margin-left: 27px;
    }
}

/* Efeito hover adicional para ícones */
.menu-item:hover i {
    transform: scale(1.1);
    transition: transform 0.2s ease;
}

/* Efeito especial para o ícone de alertas */
.menu-item:hover .fa-bell {
    animation: bellRing 0.5s ease-in-out;
}

@keyframes bellRing {
    0%, 100% { transform: scale(1.1) rotate(0deg); }
    25% { transform: scale(1.1) rotate(-10deg); }
    75% { transform: scale(1.1) rotate(10deg); }
}
</style>
